import { LOCALE_REDIRECT_KEY, i18nOptions } from '~/build/i18n'

const isLoadApp = ref(true)
export default defineNuxtRouteMiddleware(async (from, to) => {
  if (process.server) {
    return
  }

  if (!isLoadApp.value) {
    return
  }
  isLoadApp.value = false

  if (to.path !== '/') {
    return
  }
  const { $i18n } = useNuxtApp()
  const languageCode = getLanguageCode()

  if (!languageCode || !$i18n.localeCodes.value.includes(languageCode)) {
    return
  }

  if ($i18n.locale.value !== languageCode) {
    const localeRedirectCookie = useCookie(LOCALE_REDIRECT_KEY)
    localeRedirectCookie.value = languageCode
    return navigateTo(`/${languageCode}${location.search}`, {
      external: true,
    })
  }
})

/**
 * 获取语言，优先获取cookie，其次获取浏览器语言
 */
function getLanguageCode() {
  const { $i18n } = useNuxtApp()
  const { defaultLocale } = i18nOptions()
  const localeRedirectCookie = useCookie(LOCALE_REDIRECT_KEY)

  const { getBrowserLocale, locale } = $i18n

  const isNotEn = locale.value !== defaultLocale || defaultLocale !== 'en'
  // 当前语言不是英文 or 默认语言不是英文，就不请求
  if (isNotEn) {
    return
  }

  return localeRedirectCookie.value || getBrowserLocale?.() || defaultLocale
}
